import { VISA } from 'constants/debitCardTypes';
import { debitCardTypeByCountry } from 'utilities/logicByCountry';

export const isPinNotRequired = () => {
    return debitCardTypeByCountry() === VISA;
};

export const getDebitCardPoeditorKey = (type, subtype, standard) => {
    return `initialCardSelector-debitCardName_${type}_${subtype}_${standard}`;
};
